import React, { useRef, useState } from 'react'
import * as styles from './recipe-collection.module.scss'

import { Link } from 'gatsby'
import { GatsbyImage } from 'gatsby-plugin-image'

import { useLocalPath } from '../../../hooks'

import { SwiperSlide, Swiper } from 'swiper/react'
import 'swiper/css';
import "swiper/css/pagination";

import ArrowLeft from '../../../static/arrow-left.svg';
import ArrowRight from '../../../static/arrow-right.svg';
import ArticleCard from '../../Shared/ArticleCard/ArticleCard'
import HeadingLevel from '../../Shared/HeadingLevel/HeadingLevel'

const GridView = ({ array, displayStyle }) => {
    return (
        <div className={`${styles[displayStyle]} ${styles.gridContainer}`}>
            {
                array.map(({ pageTitle, thumbnailImage, slug }, index) => (
                    <div key={index} className={styles.gridItem}>
                        <Link to={useLocalPath(slug)}>
                            <GatsbyImage
                                image={thumbnailImage.gatsbyImageData}
                                alt={pageTitle || thumbnailImage.title}
                                className={styles.image}
                            />
                        </Link>
                        <Link to={useLocalPath(slug)}>
                            <p className={styles.gridTitle}>{pageTitle}</p>
                        </Link>
                    </div>
                ))
            }
        </div>
    )
}


export const SliderView = ({
    array
}) => {

    if (!array || array.length < 1) return null
    const [loop, setLoop] = useState({
        sm: !!(array.length > 1),
        md: !!(array.length > 3),
        lg: array.length > 5 ? true : false
    })

    const [centeredSlides, setCenteredSlides] = useState({
        sm: true,
        md: !!(array.length < 3),
        lg: array.length < 4 ? true : false
    })
    const goNext = (ref) => {
        ref?.current?.swiper?.slideNext()
    }

    const goPrev = (ref) => {
        ref?.current?.swiper?.slidePrev()
    }

    const swiperRef = useRef(null)

    return (
        <div className={styles.swiperContainer}>
            <div className={styles.prevIcon}>
                <ArrowLeft onClick={() => goPrev(swiperRef)} />
            </div>
            <Swiper
                breakpoints={{
                    360: {
                        slidesPerView: 1.25,
                        spaceBetween: 10,
                        centeredSlides: centeredSlides.sm,
                        // loop: loop.sm
                    },
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 30,
                        // loop: loop.md,
                        centeredSlides: centeredSlides.md
                    },
                    1400: {
                        slidesPerView: 3.5,
                        spaceBetween: 30,
                        // loop: loop.lg,
                        centeredSlides: centeredSlides.lg
                    }
                }}
                ref={swiperRef}
            >
                {
                    array.map(({ pageTitle, thumbnailImage, slug }, index) => thumbnailImage && pageTitle && slug && (
                        <SwiperSlide
                            key={index}
                        >
                            <ArticleCard
                                title={pageTitle}
                                thumbnailImage={thumbnailImage}
                                slug={slug}
                            />
                        </SwiperSlide>
                    ))
                }
            </Swiper>
            <div className={styles.nextIcon}>
                <ArrowRight onClick={() => goNext(swiperRef)} />
            </div>
        </div>
    )
}


const RecipeCollection = ({
    data
}) => {
    const {
        containerSize,
        borderPosition,
        displayStyle,
        items,
        borderSize,
        title,
        subTitle
    } = data

    return (
        <div className={`container container-${containerSize} ${styles.container}`}>
            <div className={styles.titleContainer}>
                <HeadingLevel title={title} headingLevel={3} extraClass={styles.titleHeading} subTitleClass={styles.titleSubheading} subTitle={subTitle} />
            </div>
            <div className={`${styles[borderPosition]} container-${borderSize} container`}>&nbsp;</div>
            {
                displayStyle === 'grid'
                    ? <GridView array={items} displayStyle={displayStyle} />
                    : <SliderView array={items} />
            }
        </div>
    )
}

export default RecipeCollection